import React from 'react';
import PropTypes from 'prop-types';

const ASCSortIcon = ({ handleClick, size = '1rem' }) => {
    return (
        <svg
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
            fill='#000000'
            width={size}
            height={size}
            viewBox='0 0 14 14'
            role='img'
            focusable='false'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path fill='red' d='M2.8 1v8.842H.895L3.422 13l2.526-3.158H4.053V1z' />
            <path
                fill='red'
                d='M11.268 4.853H9.595l-.348.947H8.142l1.8-4.8h.916l1.8 4.8h-1.01zM9.816 4h1.2l-.6-1.8zm.063 8.21h2.4V13H8.616v-.6l2.4-3.41h-2.4V8.2h3.6v.537z'
            />
        </svg>
    );
};

ASCSortIcon.propTypes = {
    handleClick: PropTypes.func,
};

export default ASCSortIcon;
